import { checkoutSteps } from './checkoutSteps';

import { Step } from '../model/checkoutModel';

export const getCheckoutStepUrl = (checkoutRoute: string, step?: Step) => {
	if (!step) {
		return '';
	}
	return step === checkoutSteps[0] ? checkoutRoute : `${checkoutRoute}#${step}`;
};
